import { createContext } from 'react';
import { PublicationIdentifiers } from '../types';

export const AppContext = createContext<{
  t: (key: string) => string;
  identifiers: PublicationIdentifiers;
}>({ t: () => '', identifiers: {} });
